import * as Msal from 'msal';

export default class ExAuthService {
    private app: any;
    private applicationConfig;
    private config = {
        auth: {
            clientId: '6df12fc1-bf66-4a86-92fe-52d41155bfb9'
        }
    }

    private accessTokenRequest = {
        scopes: ["user.read"],
        prompt: 'select_account',
    }

    constructor() {
        let PROD_REDIRECT_URI = 'https://ems.pgc.edu.pk';
        let redirectUri = window.location.origin;
        if (window.location.hostname !== '127.0.0.1') {
            redirectUri = PROD_REDIRECT_URI;
        }
        this.app = new Msal.UserAgentApplication(this.config);
    }
    login() {
        return this.app.loginPopup(this.accessTokenRequest).then(
            idToken => {
                const user = this.app.account.userName;
                if (user) {
                    return user;
                } else {
                    return null;
                }
            },
            () => {
                return null;
            }
        );
    };
    async logout() {
        this.app.logout();
    };
    getToken() {
        return this.app.acquireTokenSilent(this.applicationConfig.graphScopes).then(
            accessToken => {
                return accessToken;
            },
            error => {
                return this.app
                    .acquireTokenPopup(this.applicationConfig.graphScopes)
                    .then(
                        accessToken => {
                            return accessToken;
                        },
                        err => {
                            console.error(err);
                        }
                    );
            }
        );
    };
}